/* eslint-disable simple-import-sort/imports */
import React, { PureComponent } from "react";
import "../../styles/base.scss";
import "./app.scss";

import { connect } from "react-redux";
import { PropTypeShapes } from "../../types";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { uiStateSelectors, uiStateOperations } from "../../modules/uiState";
import { appStateOperations, appStateSelectors } from "../../modules/appState";
import { preferencesSelectors } from "../../modules/preferences";
import { welcomeSelectors } from "../../modules/welcome";
import { debounce } from "lodash";
import Shared from "./App.shared";

import WelcomeScreen from "../welcomeScreen";
import HarvardWelcomeScreen from "../welcomeScreen/harvard";
import Screen from "../../components/screen";
import SplitView from "../../components/splitView";
import AppMenu from "../appMenu";

import selectors from "./selectors";

import PubSub from "pubsub-js";
import PubSubTopics from "../../constants/pubSubTopics";

import Dimensions from "../../constants/styles/dimensions";
import { calendarSelectors } from "../../modules/definition/calendar";
import { itemOperations } from "../../modules/items";
import { ScreenContext } from "../../components/screen/ScreenContext";
import screenModes, { isScreenModeMobile } from "../../constants/screenModes";

import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import timeoutRates from "../../constants/timeoutRates";
import { CharacterContext } from "../../components/character/CharacterContext";
import { characterWidthMapSelectors } from "../../modules/characterWidthMap";
import { mergeDispatchToProps } from "../../utils/codeSplit";
import AppClipboardCatcher from "./AppClipboardCatcher";
import nativeCommsMessageTypes from "../../nativeComms/nativeCommsMessageTypes";
import { getModifierKeysForEvent } from "../../utils/getModifierKeys";
import { trackEvent } from "../../utils/trackAnalytics";
import keyConstants from "../../constants/keyConstants";
import SmartErrorBoundary from "../smartErrorBoundary";
import { autoUpdatesOperations, autoUpdatesSelectors } from "../../modules/autoUpdates";
import preprocessorQuery from "../../utils/preprocessorQuery";

import windowDimensions from "../../utils/windowDimensions";

//#!if harvard === true
import IosApp from "./App.ios";
//#!endif

import userAgent from "../../utils/userAgent";
import focusedFieldIsEditable from "../../utils/focusedFieldIsEditable";
import memoizeOne from "memoize-one";
import isEditable from "../../utils/isEditable";
import { timelineRangeSelectors } from "../../modules/timelineRange";

const MENU_ID = "aeonMenu";

const isReadonly = preprocessorQuery.isReadonly();
const isHarvard = preprocessorQuery.isHarvard();

const defaultScreenContextValue = { screenMode: screenModes.Desktop };

const getHarvardScreenContextValue = memoizeOne((stateScreenMode, stateWidth, stateHeight) => {
  return {
    screenMode: stateScreenMode,
    width: stateWidth,
    height: stateHeight
  };
});

const createAppMenu = isFocusedFieldEditable => (
  <AppMenu domId={MENU_ID} key="appMenu" isFocusedFieldEditable={isFocusedFieldEditable} />
);

const createWorkspaceFooterSplit = useProps => (
  <SplitView
    key="workspaceFooterSplit"
    vertical={false}
    constraints={selectors.getWorkspaceFooterConstraints(useProps.globalFontSize)}
  >
    {Shared.createWorkspace(true)}
    {Shared.createFooter}
  </SplitView>
);

const createWorkVerticalSplit = (verticalSplitConstraints, leftPanelMode, rightPanelMode, useProps) => {
  const LEFT_PANE = 0;
  const RIGHT_PANE = 2;

  const onResize = sizes => {
    let leftSize = sizes[LEFT_PANE];
    if (leftSize === Dimensions.COLLAPSED_LEFT_PANEL_WIDTH) {
      leftSize = useProps.leftPanelWidth;
    }
    let rightSize = sizes[RIGHT_PANE];
    if (rightSize === Dimensions.COLLAPSED_RIGHT_PANEL_WIDTH) {
      rightSize = useProps.rightPanelWidth;
    }
    useProps.onResizePanes(leftSize, rightSize);
  };

  const onCollapse = index => {
    if (index === RIGHT_PANE) {
      useProps.onInspectorCollapsed();
    }
  };

  const onExpand = (index, size) => {
    if (index === RIGHT_PANE) {
      useProps.onInspectorExpanded(size);
    }
  };

  return (
    <SplitView
      key="workVerticalSplit"
      vertical={true}
      hasShadow={true}
      constraints={verticalSplitConstraints}
      onCollapse={onCollapse}
      onExpand={onExpand}
      onResize={onResize}
    >
      {Shared.createLeftPanel(leftPanelMode)}
      {createWorkspaceFooterSplit(useProps)}
      {/* #!if readonly !== true */}
{/* {Shared.createInspectorPanel(rightPanelMode)}*/}
      {/* #!endif */}
    </SplitView>
  );
};

const createSidebarSplit = (verticalSplitConstraints, leftPanelMode, rightPanelMode, useProps) => {
  return (
    <SmartErrorBoundary key="sidebarErrorBoundary">
      <SplitView
        key="sidebarSplit"
        vertical={true}
        hasShadow={true}
        constraints={selectors.getDesktopSidebarSplitConstraints()}
      >
        {Shared.createSidebar}
        {createWorkVerticalSplit(verticalSplitConstraints, leftPanelMode, rightPanelMode, useProps)}
      </SplitView>
    </SmartErrorBoundary>
  );
};

const createToolbarSplit = (
  showAppMenu,
  verticalSplitConstraints,
  leftPanelMode,
  rightPanelMode,
  focusedFieldIsEditable,
  useProps
) => {
  let sidebarSplit = createSidebarSplit(verticalSplitConstraints, leftPanelMode, rightPanelMode, useProps);
  const appMenu = createAppMenu(focusedFieldIsEditable);
  const toolbarSplit = Shared.createToolbar();
  const children = showAppMenu
    ? [
      appMenu,
      //#!if harvard !== true
// toolbarSplit,
      //#!endif
      sidebarSplit
    ]
    : [
      //#!if harvard !== true
// toolbarSplit,
      //#!endif
      sidebarSplit
    ];

  return (
    <SplitView key="toolbarSplit" vertical={false} constraints={selectors.getToolbarSplitConstraints(showAppMenu)}>
      {children}
    </SplitView>
  );
};

const createWelcomeSplit = (showAppMenu, focusedFieldIsEditable) => {
  let welcomeView = <WelcomeScreen key="welcomeScreen" />;
  let safeWelcomeView = <SmartErrorBoundary key="welcomeErrorBoundary">{welcomeView}</SmartErrorBoundary>;
  const toolbarView = Shared.createToolbar();
  let children = showAppMenu
    ? [createAppMenu(focusedFieldIsEditable), toolbarView, safeWelcomeView]
    : [toolbarView, safeWelcomeView];

  //#!if harvard === true
  // Don't allow Harvard to open files from Welcome Screen
  welcomeView = <HarvardWelcomeScreen key="welcomeScreen" />;
  safeWelcomeView = <SmartErrorBoundary key="welcomeErrorBoundary">{welcomeView}</SmartErrorBoundary>;
  children = [safeWelcomeView];
  //#!endif

  return (
    <SplitView key="welcomeSplit" vertical={false} constraints={selectors.getWelcomeSplitConstraints(showAppMenu)}>
      {children}
    </SplitView>
  );
};

class App extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.onContextMenu = this.onContextMenu.bind(this);
    this.onPulseAnimationEnd = this.onPulseAnimationEnd.bind(this);
    this.onShiftItemsBy = this.onShiftItemsBy.bind(this);
    this.onSaveCustomTemplate = this.onSaveCustomTemplate.bind(this);
    this.onBeforeCut = this.onBeforeCut.bind(this);
    this.onBeforeCopy = this.onBeforeCopy.bind(this);
    this.onBeforePaste = this.onBeforePaste.bind(this);
    this.onPaste = this.onPaste.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.getCharacterWidthMap = this.getCharacterWidthMap.bind(this);
    this.getFontSize = this.getFontSize.bind(this);
    this.getGlobalFontSize = this.getGlobalFontSize.bind(this);
    this.onCloseReleaseNotesModal = this.onCloseReleaseNotesModal.bind(this);

    // Debouncing focus change so that we don't update the app for every focusout, focusin, etc.
    // call that occurs.
    this.debouncedFocusChange = debounce(this.onFocusChange, timeoutRates.APP_FOCUS_CHANGE_TIME);

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onBlur = this.onBlur.bind(this);

    this._focusedFieldIsEditable = false;
    this._pubSubInlineEditingEndedToken = null;
    this._ctrlModifierKeyPressed = false;
    this._altModifierKeyPressed = false;

    this._lastSkin = null;
    this._lastFontSize = null;

    this.characterContextValue = {
      getWidthMap: this.getCharacterWidthMap,
      getFontSize: this.getFontSize,
      getGlobalFontSize: this.getGlobalFontSize
    };

    //#!if harvard === true
    const dimensions = windowDimensions();
    this.state = {
      screenMode: dimensions.screenMode,
      width: dimensions.width,
      height: dimensions.height,
      focusedFieldIsEditable: this._focusedFieldIsEditable
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    //#!else
// this.state = {
// focusedFieldIsEditable: this._focusedFieldIsEditable
// };
    //#!endif
  }

  componentDidMount() {
    this._pubSubPulseAnimationEndToken = PubSub.subscribe(PubSubTopics.pulseAnimationEnd, this.onPulseAnimationEnd);

    // Take control of the context menu ourselves
    document.addEventListener("contextmenu", this.onContextMenu);

    // Rather than tracking when the user presses Cmd and shifting focus to a text field so the
    // clipboard command can execute properly, we can use onBeforeCut (on Mac) to handle it.
    // That way, there is no sudden focus jump (and automatic scroll) just because they hit Cmd key.
    window.addEventListener("beforecut", this.onBeforeCut);
    window.addEventListener("beforecopy", this.onBeforeCopy);
    window.addEventListener("beforepaste", this.onBeforePaste);

    // On Mac, onBeforePaste does not seem to fire, so the paste command does not get through to
    // the table cells by default.
    // So instead, we will capture this paste command here and send a PubSub command through to whoever
    // might want to listen to it.
    window.addEventListener("paste", this.onPaste);

    // Note: We had some issues previously where listening to focusin is not enough, so listening
    //       to focusout as well.
    //       Also, inline editing in particular did not always seem to trigger these events at the
    //       window level, so have added a PubSubTopic to FormEditableLabel to announce when it
    //       finishes editing, so we can watch for that too.
    //       So that we don't therefore fire way too often, using a debounced check that will mean
    //       we are not firing too many times for a single user action.
    window.addEventListener("focusin", this.debouncedFocusChange);
    window.addEventListener("focusout", this.debouncedFocusChange);

    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("keyup", this.onKeyUp);
    window.addEventListener("blur", this.onBlur);

    this._pubSubInlineEditingEndedToken = PubSub.subscribe(PubSubTopics.inlineEditingEnded, this.debouncedFocusChange);

    document.body.classList.add("desktop");

    if (userAgent.isWindowsApp()) {
      document.body.classList.add("windows");
    }
    if (userAgent.isScreenshotApp()) {
      document.body.classList.add("screenshot");
    }

    if (isReadonly) {
      document.body.classList.add("readonly");
    }
    //#!if harvard === true
    document.body.classList.add("harvard");
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    //#!endif

    this.updateDocumentDom();
  }

  componentDidUpdate() {
    this.updateDocumentDom();
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this._pubSubPulseAnimationEndToken);
    PubSub.unsubscribe(this._pubSubInlineEditingEndedToken);
    document.removeEventListener("contextmenu", this.onContextMenu);
    window.removeEventListener("beforecut", this.onBeforeCut);
    window.removeEventListener("beforecopy", this.onBeforeCopy);
    window.removeEventListener("beforepaste", this.onBeforePaste);
    window.removeEventListener("paste", this.onPaste);
    window.removeEventListener("focusin", this.debouncedFocusChange);
    window.removeEventListener("focusout", this.debouncedFocusChange);
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("keyup", this.onKeyUp);
    window.removeEventListener("blur", this.onBlur);

    document.body.classList.remove("desktop");

    //#!if readonly === true
    document.body.classList.remove("readonly");
    //#!endif
    //#!if harvard === true
    document.body.classList.remove("harvard");
    window.removeEventListener("resize", this.updateWindowDimensions);
    //#!endif
  }

  //#!if harvard === true
  updateWindowDimensions() {
    const dimensions = windowDimensions();
    if (this.state.screenMode !== dimensions.screenMode) {
      this.setState({ screenMode: dimensions.screenMode });
    }
    if (this.state.width !== dimensions.width) {
      this.setState({ width: dimensions.width });
    }
    if (this.state.height !== dimensions.height) {
      this.setState({ height: dimensions.height });
    }
  }
  //#!endif

  updateDocumentDom() {
    if (this.props.globalFontSize !== this._lastFontSize) {
      document.getElementsByTagName("html")[0].style["font-size"] = `${this.props.globalFontSize}px`;
      this._lastFontSize = this.props.globalFontSize;
    }

    if (this.props.skin !== this._lastSkin) {
      if (this._lastSkin) {
        document.body.classList.remove(`theme-${this._lastSkin}`);
      }
      document.body.classList.add(`theme-${this.props.skin}`);

      this._lastSkin = this.props.skin;
    }
  }

  // Take control of the context menu
  onContextMenu(e) {
    // By default, we will assume that we want to suppress the menu unless
    // we find a reason not to.
    let shouldSuppress = true;

    // Allow it through in debug so we can use inspector/console
    //#!if ENV !== "production"
// shouldSuppress = false;
    //#!endif

    // Allow it through on a Mac if the user is in an editable field, so that
    // the user can access the dictionary suggestions etc.
    if (userAgent.isMacApp() && isEditable(e.target)) {
      shouldSuppress = false;
    }

    // If we are meant to suppress it, stop it from showing
    if (shouldSuppress) {
      e.preventDefault();
    }
  }

  // Rather than tracking when the user presses Cmd and shifting focus to a text field so the
  // clipboard command can execute properly, we can use onBeforeCut (on Mac) to handle it.
  // That way, there is no sudden focus jump (and automatic scroll) just because they hit Cmd key.

  onBeforeCut() {
    PubSub.publishSync(PubSubTopics.clipboardEventPending, null);
  }

  onBeforeCopy() {
    PubSub.publishSync(PubSubTopics.clipboardEventPending, null);
  }

  onBeforePaste() {
    PubSub.publishSync(PubSubTopics.clipboardEventPending, null);
  }

  // On Mac, onBeforePaste does not seem to fire, so the paste command does not get through to
  // the table cells by default.
  // So instead, we will capture this paste command here and send a PubSub command through to whoever
  // might want to listen to it.

  onPaste(e) {
    PubSub.publishSync(PubSubTopics.paste, e.clipboardData);
  }

  onFocusChange(_eventOrMsg) {
    const fieldIsEditable = focusedFieldIsEditable();
    if (fieldIsEditable !== this._focusedFieldIsEditable) {
      PubSub.publish(PubSubTopics.sendNativeMessage, {
        msg: nativeCommsBroadcastMessageTypes.FOCUS_CHANGED,
        isEditable: fieldIsEditable
      });
      this._focusedFieldIsEditable = fieldIsEditable;
      this.setState({ focusedFieldIsEditable: fieldIsEditable });
    }
  }

  onPulseAnimationEnd() {
    this.props.onPulseAnimationEnd();
  }

  onKeyDown(e) {
    const modifiers = getModifierKeysForEvent(e);
    // Do not handle global input keys when the focused field is currently editable
    if (this._focusedFieldIsEditable) {
      return;
    }
    if (modifiers.COMMAND || modifiers.CONTROL) {
      PubSub.publishSync(PubSubTopics.ctrlModifierKeyDown, e);
      this._ctrlModifierKeyPressed = true;
    }
    if (modifiers.ALT) {
      PubSub.publishSync(PubSubTopics.altModifierKeyDown, e);
      this._altModifierKeyPressed = true;
    }

    if (e.key === keyConstants.Escape) {
      if (
        this.props.settingsModalOpen ||
        this.props.syncSettingsModalOpen ||
        this.props.preferencesModalOpen ||
        this.props.backupModalOpen ||
        this.props.aboutModalOpen ||
        this.props.exportImagePreviewModalOpen ||
        this.props.exportTsfModalOpen ||
        this.props.exportCsvModalOpen ||
        this.props.importCsvModalOpen ||
        this.props.saveTemplateModalOpen ||
        this.props.inspectorModalOpen ||
        this.props.printPreviewModalOpen ||
        this.props.showUpgradeWizard ||
        this.props.showTemplateWizard ||
        this.props.showUpdateModal ||
        this.props.fileVersionTooLowModalOpen
      ) {
        e.stopPropagation();
        e.preventDefault();
      }
      PubSub.publishSync(PubSubTopics.escapeKeyDown, e);
    }
  }

  onKeyUp(e) {
    if (this._focusedFieldIsEditable) {
      return;
    }
    if (this._ctrlModifierKeyPressed) {
      const modifiers = getModifierKeysForEvent(e);
      if (!modifiers.COMMAND && !modifiers.CONTROL) {
        PubSub.publishSync(PubSubTopics.ctrlModifierKeyUp, e);
        this._ctrlModifierKeyPressed = false;
      }
    }
    if (this._altModifierKeyPressed) {
      const modifiers = getModifierKeysForEvent(e);
      if (!modifiers.ALT) {
        PubSub.publishSync(PubSubTopics.altModifierKeyUp, e);
        this._altModifierKeyPressed = false;
      }
    }
  }

  onBlur() {
    PubSub.publishSync(PubSubTopics.ctrlModifierKeyUp);
    this._ctrlModifierKeyPressed = false;
    PubSub.publishSync(PubSubTopics.altModifierKeyUp);
    this._altModifierKeyPressed = false;
  }

  renderWelcomeScreen() {
    return (
      <Screen key="screen">
        {createWelcomeSplit(this.props.showAppMenu, this.state.focusedFieldIsEditable)}
        {this.props.preferencesModalOpen ? Shared.createPreferencesModal(this.props.onClosePreferencesModal) : null}
        {this.props.backupModalOpen ? Shared.createBackupModal(this.props.onCloseBackupModal) : null}
        {this.props.aboutModalOpen ? Shared.createAboutModal(this.props.onCloseAboutModal) : null}
        {this.props.fileVersionTooLowModalOpen && !this.props.showUpdateModal
          ? Shared.createFileVersionTooLowModal(this.props.onCloseFileVersionTooLowModal)
          : null}
        {this.props.showUpdateModal ? Shared.createUpdateModal(this.props.onCloseUpdateModal) : null}
        {this.props.showReleaseNotesModal ? Shared.createReleaseNotesModal(this.onCloseReleaseNotesModal) : null}
      </Screen>
    );
  }

  onShiftItemsBy(duration) {
    this.props.onShiftItemsBy(this.props.selectedItemIds, duration);
  }

  onSaveCustomTemplate(name) {
    // A bit of a kludge:
    // Pass it off to our nativeCommsReceiver to handle, since that has access to state
    // to pull the definitions...
    window.nativeCommsReceiver(nativeCommsMessageTypes.SAVE_AS_TEMPLATE_WITH_NAME, name);

    trackEvent("customTemplateSave", "customTemplate");
  }

  onCloseReleaseNotesModal() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.RELEASE_NOTES_READ
    });
  }

  renderMainScreen() {
    const verticalSplitConstraints = this.props.verticalSplitConstraints;
    const leftPanelMode = this.props.leftPanelMode;
    const rightPanelMode = this.props.rightPanelMode;

    return [
      <Screen key="screen">
        {Shared.wrapInDragDropContainer(
          createToolbarSplit(
            this.props.showAppMenu,
            verticalSplitConstraints,
            leftPanelMode,
            rightPanelMode,
            this.state.focusedFieldIsEditable,
            this.props
          )
        )}
        {Shared.createNotificationPanel}
        {Shared.createTutorialNotification}
        {this.props.settingsModalOpen ? Shared.createSettingsModal(this.props.onCloseSettingsModal) : null}
        {this.props.syncSettingsModalOpen ? Shared.createSyncSettingsModal(this.props.onCloseSyncSettingsModal) : null}
        {this.props.preferencesModalOpen ? Shared.createPreferencesModal(this.props.onClosePreferencesModal) : null}
        {this.props.backupModalOpen ? Shared.createBackupModal(this.props.onCloseBackupModal) : null}
        {this.props.printPreviewModalOpen ? Shared.createPrintPreviewModal(this.props.onClosePrintPreviewModal) : null}
        {this.props.aboutModalOpen ? Shared.createAboutModal(this.props.onCloseAboutModal) : null}
        {this.props.exportImagePreviewModalOpen
          ? Shared.createExportImagePreviewModal(this.props.onCloseExportImagePreviewModal)
          : null}
        {this.props.exportTsfModalOpen ? Shared.createExportTsfModal(this.props.onCloseExportTsfModal) : null}
        {this.props.exportCsvModalOpen ? Shared.createExportCsvModal(this.props.onCloseExportCsvModal) : null}
        {this.props.importCsvModalOpen ? Shared.createImportCsvModal(this.props.onCloseImportCsvModal) : null}
        {this.props.saveTemplateModalOpen ? Shared.createSaveTemplateModal(this.props.onCloseSaveTemplateModal) : null}
        {this.props.inspectorModalOpen ? Shared.createInspectorModal(this.props.onCloseInspectorModal) : null}
        {this.props.fileVersionTooLowModalOpen && !this.props.showUpdateModal
          ? Shared.createFileVersionTooLowModal(this.props.onCloseFileVersionTooLowModal)
          : null}
        {this.props.showUpdateModal ? Shared.createUpdateModal(this.props.onCloseUpdateModal) : null}
        {this.props.showReleaseNotesModal ? Shared.createReleaseNotesModal(this.onCloseReleaseNotesModal) : null}
      </Screen>,
      this.props.menuPopoverType
        ? Shared.createMenuPopover(
          this.props.menuPopoverType,
          this.props.calendar,
          () => {
            this.props.onSetMenuPopoverType(null);
          },
          this.onShiftItemsBy,
          this.onSaveCustomTemplate,
          this.props.dateRangeFrom,
          this.props.dateRangeTo
        )
        : null
    ];
  }

  getCharacterWidthMap() {
    return this.props.characterWidthMap;
  }

  getFontSize() {
    return this.props.fontSize;
  }

  getGlobalFontSize() {
    return this.props.globalFontSize;
  }

  render() {
    const appStyle = {
      lineHeight: `${Dimensions.BASE_LINE_HEIGHT}em`
    };

    let className = `desktop ${this.props.showAppMenu ? "withAppMenu" : ""}`;

    let primaryView = this.props.isWelcomeVisible ? this.renderWelcomeScreen() : this.renderMainScreen();

    //#!if harvard === true
    if (isScreenModeMobile(this.state.screenMode)) {
      className = "harvardMobile";
      primaryView = <IosApp />;
    }
    //#!endif

    const contextState = isHarvard
      ? getHarvardScreenContextValue(this.state.screenMode, this.state.width, this.state.height)
      : defaultScreenContextValue;

    return (
      <SmartErrorBoundary key="appErrorBoundary">
        <ScreenContext.Provider value={contextState}>
          <CharacterContext.Provider value={this.characterContextValue}>
            <AppClipboardCatcher className={className} appStyle={appStyle}>
              {Shared.createInlineSvg()}
              {primaryView}
            </AppClipboardCatcher>
          </CharacterContext.Provider>
        </ScreenContext.Provider>
      </SmartErrorBoundary>
    );
  }
}

App.propTypes = {
  showAppMenu: PropTypes.bool.isRequired,
  isWelcomeVisible: PropTypes.bool.isRequired,
  verticalSplitConstraints: PropTypeShapes.splitConstraintsList,
  leftPanelMode: PropTypes.string,
  rightPanelMode: PropTypes.string.isRequired,
  settingsModalOpen: PropTypes.bool.isRequired,
  onCloseSettingsModal: PropTypes.func.isRequired,

  syncSettingsModalOpen: PropTypes.bool.isRequired,
  onCloseSyncSettingsModal: PropTypes.func.isRequired,

  preferencesModalOpen: PropTypes.bool.isRequired,
  onClosePreferencesModal: PropTypes.func.isRequired,

  backupModalOpen: PropTypes.bool.isRequired,
  onCloseBackupModal: PropTypes.func.isRequired,

  aboutModalOpen: PropTypes.bool.isRequired,
  onCloseAboutModal: PropTypes.func.isRequired,

  exportImagePreviewModalOpen: PropTypes.bool.isRequired,
  onCloseExportImagePreviewModal: PropTypes.func.isRequired,

  exportTsfModalOpen: PropTypes.bool.isRequired,
  onCloseExportTsfModal: PropTypes.func.isRequired,

  exportCsvModalOpen: PropTypes.bool.isRequired,
  onCloseExportCsvModal: PropTypes.func.isRequired,

  importCsvModalOpen: PropTypes.bool.isRequired,
  onCloseImportCsvModal: PropTypes.func.isRequired,

  saveTemplateModalOpen: PropTypes.bool.isRequired,
  onCloseSaveTemplateModal: PropTypes.func.isRequired,

  inspectorModalOpen: PropTypes.bool.isRequired,
  onCloseInspectorModal: PropTypes.func.isRequired,

  printPreviewModalOpen: PropTypes.bool.isRequired,
  onClosePrintPreviewModal: PropTypes.func.isRequired,

  fileVersionTooLowModalOpen: PropTypes.bool.isRequired,
  onCloseFileVersionTooLowModal: PropTypes.func.isRequired,

  showUpdateModal: PropTypes.bool.isRequired,
  onCloseUpdateModal: PropTypes.func.isRequired,

  showReleaseNotesModal: PropTypes.bool.isRequired,

  fontSize: PropTypes.number.isRequired,
  globalFontSize: PropTypes.number.isRequired,
  skin: PropTypes.string.isRequired,
  onInspectorCollapsed: PropTypes.func.isRequired,
  onInspectorExpanded: PropTypes.func.isRequired,
  onResizePanes: PropTypes.func.isRequired,
  onPulseAnimationEnd: PropTypes.func.isRequired,
  onShiftItemsBy: PropTypes.func.isRequired,
  menuPopoverType: PropTypes.string,
  onSetMenuPopoverType: PropTypes.func.isRequired,
  calendar: PropTypeShapes.calendar.isRequired,
  selectedItemIds: ImmutablePropTypes.list.isRequired,
  characterWidthMap: ImmutablePropTypes.map.isRequired,
  showUpgradeWizard: PropTypes.bool.isRequired,
  showTemplateWizard: PropTypes.bool.isRequired,

  leftPanelWidth: PropTypes.number,
  rightPanelWidth: PropTypes.number,
  dateRangeFrom: PropTypeShapes.date,
  dateRangeTo: PropTypeShapes.date
};

const mapStateToProps = state => {
  const showReleaseNotesModal = autoUpdatesSelectors.showReleaseNotesModal(state.present);
  const dimensions = windowDimensions();
  return {
    showAppMenu: selectors.getShowAppMenu(),
    isWelcomeVisible: state.present.welcome.isVisible,
    verticalSplitConstraints: selectors.getWorkSplitConstraints(state.present, dimensions.width),
    leftPanelMode: appStateSelectors.getLeftPanelMode(state.present),
    rightPanelMode: appStateSelectors.getRightPanelMode(state.present),
    settingsModalOpen: uiStateSelectors.getUiStateSettingsModalOpen(state.present),
    preferencesModalOpen: uiStateSelectors.getUiStatePreferencesModalOpen(state.present),
    backupModalOpen: uiStateSelectors.getUiStateBackupModalOpen(state.present),
    aboutModalOpen: uiStateSelectors.getUiStateAboutModalOpen(state.present),
    exportImagePreviewModalOpen: uiStateSelectors.getUiStateExportImagePreviewModalOpen(state.present),
    exportTsfModalOpen: uiStateSelectors.getUiStateExportTsfModalOpen(state.present),
    exportCsvModalOpen: uiStateSelectors.getUiStateExportCsvModalOpen(state.present),
    importCsvModalOpen: uiStateSelectors.getUiStateImportCsvModalOpen(state.present),
    saveTemplateModalOpen: uiStateSelectors.getSaveTemplateModalOpen(state.present),
    inspectorModalOpen: uiStateSelectors.getUiStateInspectorModalOpen(state.present),
    printPreviewModalOpen: uiStateSelectors.getUiStatePrintPreviewModalOpen(state.present),
    syncSettingsModalOpen: uiStateSelectors.getUiStateSyncSettingsModalOpen(state.present),
    menuPopoverType: uiStateSelectors.getMenuPopoverType(state.present),
    fontSize: appStateSelectors.getFontSize(state.present),
    globalFontSize: preferencesSelectors.getGlobalFontSize(state.present),
    skin: preferencesSelectors.getSkin(state.present),
    calendar: calendarSelectors.getCalendar(state.present),
    selectedItemIds: uiStateSelectors.getSelectedItems(state.present),
    characterWidthMap: characterWidthMapSelectors.getCharacterWidthMap(state.present),
    showUpgradeWizard: welcomeSelectors.getShowUpgradeWizard(state.present),
    showTemplateWizard: welcomeSelectors.getShowTemplateWizard(state.present),
    showUpdateModal: autoUpdatesSelectors.showUpdateModal(state.present),
    showReleaseNotesModal,
    fileVersionTooLowModalOpen: uiStateSelectors.getUiStateFileVersionTooLowModalOpen(state.present),
    leftPanelWidth: appStateSelectors.getLeftPanelWidth(state.present),
    rightPanelWidth: appStateSelectors.getRightPanelWidth(state.present),
    dateRangeFrom: timelineRangeSelectors.getRangeFrom(state.present),
    dateRangeTo: timelineRangeSelectors.getRangeTo(state.present)
  };
};

const readonlyActions = {
  onSetMenuPopoverType: uiStateOperations.setMenuPopoverType,
  onResizePanes: appStateOperations.setPanelWidths,
  onCloseSettingsModal: uiStateOperations.hideSettingsModal,
  onClosePreferencesModal: uiStateOperations.hidePreferencesModal,
  onCloseBackupModal: uiStateOperations.hideBackupModal,
  onCloseAboutModal: uiStateOperations.hideAboutModal,
  onCloseExportImagePreviewModal: uiStateOperations.hideExportImagePreviewModal,
  onCloseExportCsvModal: uiStateOperations.hideExportCsvModal,
  onCloseImportCsvModal: uiStateOperations.hideImportCsvModal,
  onCloseInspectorModal: uiStateOperations.hideInspectorModal,
  onClosePrintPreviewModal: uiStateOperations.hidePrintPreviewModal,
  onCloseFileVersionTooLowModal: uiStateOperations.hideFileVersionTooLowModal,
  onCloseUpdateModal: autoUpdatesOperations.hideUpdateModal
};

const editingActions = {
  onInspectorCollapsed: appStateOperations.hideRightPanel,
  onInspectorExpanded: size => appStateOperations.showRightPanel(size),
  onPulseAnimationEnd: uiStateOperations.pulsateIcon,
  onShiftItemsBy: (selectedItemIds, duration) => {
    if (duration) {
      return itemOperations.moveByTimespan(selectedItemIds.toArray(), duration.toObject());
    }
  },
  onCloseSyncSettingsModal: uiStateOperations.hideSyncSettingsModal,
  onCloseExportTsfModal: uiStateOperations.hideExportTsfModal,
  onCloseSaveTemplateModal: uiStateOperations.hideSaveTemplateModal
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

const connectedApp = connect(mapStateToProps, mapDispatchToProps)(App);

export default connectedApp;
